import { BrokenImage } from '@components/index';
import styled from 'styled-components';

export const Overlay = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 900;
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 16px 25px;
  padding-bottom: 24px;
  width: 604px;
  height: 617px;
  display: flex;
  align-self: center;
  justify-self: center;
  flex-direction: column;
  z-index: 100;
  position: fixed;
  overflow: hidden;

  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 16px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const Title = styled.h3`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #1b203a;
  margin: unset;
`;

export const CloseButton = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }

  span {
    display: inline-flex;
  }
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  margin: unset;
`;

export const Form = styled.form`
  margin-top: 16px;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const GroupForm = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;

export const InputWrapper = styled.div`
  position: relative;

  &[data-top] {
    margin-top: 12px;
  }
`;

export const InputWrapperUrl = styled.div`
  position: relative;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 24px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &[data-top] {
    margin-top: 12px;
  }
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #474d66;

  &[data-optional] {
    color: #8f95b2;
  }

  &[data-optional-text] {
    color: #8f95b2;
    ::after {
      content: ' (Optional)';
    }
  }
`;

export const InputField = styled.div`
  padding: 10px 12px 10px 16px;
  gap: 84px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 8px;
  margin-top: 8px;

  span {
    display: inline-flex;
    cursor: pointer;
  }

  &[data-no-bottom-arc='true'] {
    border-radius: 8px 8px 0px 0px;
  }
`;

export const InputFieldManufacturer = styled(InputField)`
  padding: 10px 12px 10px 6px;
`;

export const Input = styled.input`
  flex: 1;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;

  :-webkit-autofill {
    background-clip: text;
    -webkit-background-clip: text;
  }
`;

export const AddButton = styled.button`
  padding: 13px;
  width: 42px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  span {
    display: inline-flex;
  }
`;

export const RemoveButton = styled.button`
  padding: 13px;
  width: 42px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  margin-right: -13px;
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 8px;
  margin-top: 16px;
`;

export const Button = styled.button`
  padding: 10px 16px;
  font-weight: 500;
  font-size: 14px;
  border-radius: 8px;
  border: none;
  outline: none;

  &[data-blue='true'] {
    background: #1371fe;
    color: #ffffff;

    :disabled {
      background-color: #edeff4;
      color: #c1c4d6;
    }
  }

  &[data-neutral='true'] {
    background: transparent;
    color: #474d66;
  }
`;

export const QuantitySelect = styled.div`
  padding: 10px;
  width: 165px;
  height: 42px;
  background: #f9fafc;
  border: 1px solid #e6e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
`;

export const Quantitylabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
`;

export const QuantityValue = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #474d66;
  margin: unset;
`;

export const QuantityButton = styled.button`
  display: flex;
  align-items: center;
  padding: 1px;
  background-color: transparent;
  border: none;
  outline: none;
  border-radius: 8px;

  span {
    display: inline-flex;
  }

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }

  :disabled {
    span {
      svg {
        fill: #d8dae5;
      }
    }
  }
`;

export const CleanButton = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  padding: 0;
  padding-top: 2px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const LoadingSearch = styled.img`
  height: 20px;
  width: 20px;
`;

export const IconLeft = styled(BrokenImage)`
  height: 28px;
  width: 28px;
  border: 1px solid #d8dae5;
  border-radius: 4px;
  object-fit: cover;
  -webkit-user-drag: none;
  user-select: none;
  padding: 2px;
`;

export const GlassIcon = styled.div`
  height: 24px;
  margin-left: 10px;
`;
